var DatePickerMode;
(function (DatePickerMode) {
    DatePickerMode["DECADES"] = "decades";
    DatePickerMode["MONTHLY"] = "monthly";
    DatePickerMode["WEEK"] = "week";
    DatePickerMode["YEARLY"] = "yearly";
})(DatePickerMode || (DatePickerMode = {}));
export { DatePickerMode, };
//# sourceMappingURL=date-picker-constants.js.map